import { message } from 'antd'
import axios from 'axios'
import Cookies from 'js-cookie'
import { apiPrefix } from '../js/config'
import statusCodes from '../js/statusCode'

import _ from 'lodash'

let { SUCCESS, TOKEN_OUTDATED, NO_AUTH, YZM_ERROR, FETCH_FAILD, ADD_FAILD, TOKEN_NO_EXIST } = statusCodes

let confing = {
    baseURL: apiPrefix,
    headers: {
        common: {
            token: Cookies.get('token') || ''
        }
    }
}

const commonHandle = (response: any) => {
    let { status, message: msg } = response.data

    switch (status) {
        case SUCCESS:
            message.success('操作成功')
            break;
        case TOKEN_OUTDATED:
            Cookies.set('token', '')
            window.location.reload()
            break;
        case NO_AUTH:
            message.error(msg)
            break;
        case YZM_ERROR:
            message.error(msg)
            break;
        case FETCH_FAILD:
            message.error(msg)
            break;
        case ADD_FAILD:
            message.error(msg)
            break;
        case TOKEN_NO_EXIST:
            Cookies.set('token', '')
            window.location.reload()
            break;
        default:
            message.error(msg)
    }
}

const tokenHandle = (response: any) => {
    let { status, message: msg } = response.data

    if (status === TOKEN_OUTDATED || status === TOKEN_NO_EXIST) {
        message.error('登录失效')
        Cookies.set('token', '')

        window.location.reload()
    }
}

// 请求失败
const handleNetError = (error: any) => {
    return Promise.reject(error)
}

// 返回data数据
const baseAxios = axios.create(confing)

baseAxios.interceptors.response.use((response) => {
    commonHandle(response)
    return response.data.data
}, handleNetError)

// 返回data数据，不提示消息
const baseAxiosNoInfo = axios.create(confing)

baseAxiosNoInfo.interceptors.response.use((response) => {
    tokenHandle(response)
    return response.data.data
}, handleNetError)

// 返回data、状态
const baseAxiosComplete = axios.create(confing)

baseAxiosComplete.interceptors.response.use((response) => {
    commonHandle(response)
    return response.data
}, handleNetError)

// 适用于编辑页操作
const axiosHandleEvent = axios.create(confing)

axiosHandleEvent.interceptors.response.use((response) => {
    commonHandle(response)

    let data = response.data
    let status: number = response.data.status

    // 成功后返回上一页
    if (status === SUCCESS) {
        window.history.go(-1)
    }

    return data

}, handleNetError)

// 表格
const axiosTable = axios.create(confing)

axiosTable.interceptors.response.use((response) => {
    tokenHandle(response)

    if (response.data.status === NO_AUTH) {
        message.error(response.data.message)
    }

    if (response.data.data === null || response.data.status === NO_AUTH) {
        return {
            total: 0,
            pageSize: 8,
            current: 1,
            records: []
        }
    }

    return response.data.data
}, handleNetError)

export default baseAxios // 直接返回data数据，并且有提示信息

export {
    baseAxiosNoInfo, // 适合选项菜单类型的查询，无提示信息，直接返回data
    baseAxiosComplete, // 适合提交操作不需要返回上一页时使用（处理token及各种失败状态码的提示信息，返回response.data【包括：data 和 status】）
    axiosHandleEvent, //  适合内页操作时使用（增删改成功时，会返回上一页）
    axiosTable // 适合表格使用（无提示信息）
}